"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var sequence = function sequence(array, callback, index) {
  if (typeof index === "undefined") {
    index = 0;
  }

  array[index](function () {
    index++;

    if (index === array.length) {
      callback();
    } else {
      sequence(array, callback, index);
    }
  });
};

var _default = sequence;
exports.default = _default;